"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _Avatar = _interopRequireDefault(require("../Avatar/Avatar"));

var _elements = require("../../styles/elements");

var _icons = require("../../assets/icons");

var _UserSettings = require("./UserSettings.styles");

var _status = require("../../constants/status");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Menu = _Dropdown["default"].Menu,
    Button = _Dropdown["default"].Button;

var UserSettings = function UserSettings(_ref) {
  var userInfo = _ref.userInfo,
      list = _ref.list,
      defaultVisible = _ref.defaultVisible;
  var header = (0, _jsxRuntime.jsxs)("button", {
    type: "button",
    className: "grui",
    css: [_elements.button.styles.preflight, _UserSettings.styles.header, process.env.NODE_ENV === "production" ? "" : ";label:header;"],
    children: [(0, _jsxRuntime.jsx)(_Avatar["default"], _objectSpread({
      css: _UserSettings.styles.avatar,
      className: "grui mr-5"
    }, userInfo)), (0, _jsxRuntime.jsxs)("div", {
      css: _UserSettings.styles.statusWrapper,
      children: [(0, _jsxRuntime.jsx)("div", {
        css: [_elements.text.styles.text2Xs, _elements.text.styles.fontMedium, process.env.NODE_ENV === "production" ? "" : ";label:header;"],
        children: userInfo.chatName
      }), (0, _jsxRuntime.jsxs)("div", {
        css: [_elements.text.styles.text3Xs, _elements.text.styles.textDark, process.env.NODE_ENV === "production" ? "" : ";label:header;"],
        children: ["Status:\xA0", (0, _jsxRuntime.jsx)("span", {
          css: [_elements.text.styles.fontMedium, _elements.indicator.statusText[userInfo.status], process.env.NODE_ENV === "production" ? "" : ";label:header;"],
          children: userInfo.statusText
        })]
      })]
    }), (0, _jsxRuntime.jsx)("span", {
      className: "grui ml-auto",
      children: (0, _jsxRuntime.jsx)(_icons.ChevronRight, {
        className: "grui align-middle"
      })
    })]
  });
  var footer = (0, _jsxRuntime.jsxs)("button", {
    type: "button",
    className: "grui",
    css: [_UserSettings.styles.footer, _elements.button.styles.link, process.env.NODE_ENV === "production" ? "" : ";label:footer;"],
    children: [(0, _jsxRuntime.jsx)(_icons.Exit, {}), (0, _jsxRuntime.jsx)("span", {
      children: "Sign out"
    })]
  });

  var menu = function menu(data) {
    return (0, _jsxRuntime.jsx)(Menu, {
      css: _UserSettings.styles.menu,
      children: data.map(function (_ref2) {
        var title = _ref2.title,
            key = _ref2.key,
            mark = _ref2.mark;
        return (0, _jsxRuntime.jsx)(Menu.Item, {
          itemKey: key,
          css: [mark && _elements.text.styles.fontMedium, mark && _elements.text.styles.textBlack, process.env.NODE_ENV === "production" ? "" : ";label:menu;"],
          children: title
        }, key);
      })
    });
  };

  return (0, _jsxRuntime.jsx)(_Dropdown["default"], {
    overlay: menu(list),
    header: header,
    footer: footer,
    defaultVisible: defaultVisible,
    hasMinWidth: true,
    autoHeight: true,
    children: (0, _jsxRuntime.jsx)(Button, {
      size: "small",
      textBtn: true,
      onClick: userInfo.onClick,
      children: userInfo.userName
    })
  });
};

UserSettings.propTypes = {
  /**
   * Current userInfo
   */
  userInfo: (0, _propTypes.shape)({
    status: _propTypes.string,
    statusText: _propTypes.string,
    chatName: _propTypes.string,
    avatar: _propTypes.string,
    userName: _propTypes.string,

    /**
     * Handler for clicking user
     */
    onClick: _propTypes.func
  }).isRequired,

  /**
   * list of settings
   */
  list: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: _propTypes.string.isRequired,
    title: _propTypes.string.isRequired
  })).isRequired,
  status: (0, _propTypes.oneOf)(Object.values(_status.ONLINE_STATUS)),
  defaultVisible: _propTypes.bool
};
UserSettings.defaultProps = {
  status: _status.ONLINE_STATUS.offline,
  defaultVisible: false
};
var _default = UserSettings;
exports["default"] = _default;
//# sourceMappingURL=UserSettings.js.map